import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const POSTER =
  "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/kv76mxcm_IMG_0083.webp";
const VIDEO =
  "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/626hpd4o_IMG_0092.mp4";

const fade = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => {
  const { t } = useLang();
  return (
    <section className="hero" id="hero" data-testid="hero-section">
      <div className="hero__bg">
        <video
          className="hero__media"
          autoPlay
          muted
          loop
          playsInline
          poster={POSTER}
          data-testid="hero-video"
        >
          <source src={VIDEO} type="video/mp4" />
        </video>
        <div className="hero__veil" />
      </div>

      <div className="hero__content">
        <motion.p className="hero__est" {...fade(2.1)} data-testid="hero-est">
          {t.hero.est}
        </motion.p>
        <motion.h1 className="hero__message" {...fade(2.3)} data-testid="hero-title">
          <span>{t.hero.msgA}</span>
          <span><em>{t.hero.msgB}</em></span>
          <span>{t.hero.msgC}</span>
        </motion.h1>
        <motion.p className="hero__sub" {...fade(2.7)} data-testid="hero-sub">
          {t.hero.sub}
        </motion.p>
        <motion.div className="hero__ctas" {...fade(2.9)}>
          <a href="tel:+306936614442" className="btn btn--ghost" data-testid="hero-reserve-cta">
            {t.hero.cta}
          </a>
          <Link to="/menu" className="btn btn--ghost" data-testid="hero-menu-cta">
            {t.hero.ctaMenu}
          </Link>
        </motion.div>
      </div>

      <motion.div className="hero__bottom" {...fade(3.1)}>
        <span className="hero__hours">{t.hero.hours}</span>
        <span className="hero__scroll">
          {t.hero.scroll}
          <span className="hero__scroll-line" />
        </span>
        <span className="hero__hours">{t.hero.sub}</span>
      </motion.div>
    </section>
  );
};

export default Hero;
